var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vModal vModalDefault" }, [
    _c(
      "div",
      { staticClass: "vModalDefaultHeader" },
      [
        _vm._t("header", function () {
          return [_vm._v("Default Header")]
        }),
        _c(
          "button",
          {
            staticClass: "vModalDefaultCloseButton",
            on: {
              click: function ($event) {
                return _vm.cancel()
              },
            },
          },
          [_vm._v("close")]
        ),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "vModalDefaultBody", class: _vm.bodyScrollStyle },
      [
        _vm._t("body", function () {
          return [_vm._v("Default Body")]
        }),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "vModalDefaultFooter" },
      [
        _vm._t("footer", function () {
          return [
            _c(
              "button",
              {
                staticClass: "rbButton",
                on: {
                  click: function ($event) {
                    return _vm.cancel()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.mergedOptions.labels.buttons.cancel))]
            ),
            _c(
              "button",
              {
                staticClass: "rbButton mainButton",
                attrs: { disabled: _vm.isDisabled },
                on: {
                  click: function ($event) {
                    return _vm.hide()
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.mergedOptions.labels.buttons.apply) + " "
                ),
              ]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }